import { useState } from 'react';
import SSIAP1 from '../Assets/ssiap1mini.png'
import SSIAP2 from '../Assets/ssiap2mini.png'
import SSIAP3 from '../Assets/ssiap3mini.png'
import { TheNav, Fotter } from './Home'

export const Form = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    selectedOption: ''
  });

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, subject, message } = formData;
    const mailtoLink = `mailto:direction.francilienne.formation@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\nMessage: ${message}`
    )}`;
    window.location.href = mailtoLink;
  };

  return (
    <div className="w-full undi:px-[200px] px-[50px] pb-14 mt-[14vh]">
      <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center font-times">Contactez-nous</h2>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
            Nom complet
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full px-6 py-2 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-[#D72427]"
            required
          />
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-6 py-2 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-[#D72427]"
            required
          />
        </div>

        <div className="relative">
          <label htmlFor="dropdown" className="block text-sm font-medium text-gray-700 mb-1">
            Sujet
          </label>
          <button
            type="button"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="w-full flex justify-between items-center px-6 py-2 border border-gray-300 rounded-full bg-white focus:outline-none focus:ring-2 focus:ring-[#D72427]"
          >
            {formData.selectedOption || "Sélectionnez une option"}
            <svg
              className={`w-5 h-5 ml-2 transition-transform ${isDropdownOpen ? 'transform rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {isDropdownOpen && (
            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg">
              {/* Items du dropdown (à remplir) */}
              <div className="py-1">
                {/* Exemple d'item - à remplacer par vos options */}
                <button
                  type="button"
                  className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
                  onClick={() => {
                    setFormData({...formData, selectedOption: "SSIAP1"});
                    setIsDropdownOpen(false);
                  }}
                >
                  SSIAP1
                </button>
                <button
                  type="button"
                  className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
                  onClick={() => {
                    setFormData({...formData, selectedOption: "SSIAP2"});
                    setIsDropdownOpen(false);
                  }}
                >
                  SSIAP2
                </button>
                <button
                  type="button"
                  className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
                  onClick={() => {
                    setFormData({...formData, selectedOption: "SSIAP3"});
                    setIsDropdownOpen(false);
                  }}
                >
                  SSIAP3
                </button>
                <button
                  type="button"
                  className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
                  onClick={() => {
                    setFormData({...formData, selectedOption: "APS"});
                    setIsDropdownOpen(false);
                  }}
                >
                 APS
                </button>
                <button
                  type="button"
                  className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
                  onClick={() => {
                    setFormData({...formData, selectedOption: "H0B0"});
                    setIsDropdownOpen(false);
                  }}
                >
                  H0B0
                </button>
                <button
                  type="button"
                  className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
                  onClick={() => {
                    setFormData({...formData, selectedOption: "SST"});
                    setIsDropdownOpen(false);
                  }}
                >
                  SST
                </button>
                <button
                  type="button"
                  className="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100"
                  onClick={() => {
                    setFormData({...formData, selectedOption: "Autres"});
                    setIsDropdownOpen(false);
                  }}
                >
                  Autres
                </button>
                {/* Ajoutez d'autres options ici */}
              </div>
            </div>
          )}
        </div>

        <div>
          <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            rows="4"
            value={formData.message}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D72427]"
            required
          />
        </div>

        <div>
          <button
            type="submit"
            className="w-full mt-6 bg-[#D72427] text-white text-lg font-bold py-3 px-4 rounded-full hover:bg-[#d72427e0] transition duration-300 focus:outline-none focus:ring-2 focus:ring-[#D72427] focus:ring-offset-2"
          >
            Envoyer
          </button>
        </div>
      </form>
    </div>
  );
};

export const Contact = () =>{
    return(
        <>
            <TheNav/>
            <Form/>
            <Fotter/>
        </>
    );
}